import { httpRequest } from "../../../utils/HttpRequest";
import { ISearchPage, IPage, IMdCmFields } from "@/types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";

//详情
export interface IRemainingDetail {
    id: string,
    shopCode: string;//门店编码
    shopName: string;//门店名称
    partnerCode: string;//客户、供应商编码
    partnerName: string;//客户、供应商名称
    remainingAmount: number;//客户剩余金额
    rechAmount: number;//客户充值金额
    billAmount: number;//客户核销账单金额
    remainingAmount2: number;//客户应该剩余金额
    diffAmount: number;//差异金额
}


//搜索条件
export interface IRemainingSearchFields extends Partial<IRemainingDetail>{
    supplier?: string;
}

export interface IRemainingSearch
    extends IRemainingSearchFields, ISearchPage {
}

export interface IRemainingStatistics{
    diffAmount: number;
}


class RemainingService {
    async page(searchVo: IRemainingSearch) {
        const apiUrl = "/remainingMonitoring/pg";
        return await httpRequest.post<IPage<IRemainingDetail>>(apiUrl, searchVo);
    }
    async statistics(searchVo: IRemainingSearchFields) {
        const apiUrl = "/remainingMonitoring/statistics";
        return await httpRequest.post<IRemainingStatistics>(apiUrl, searchVo);
    }
    //导出
    async export(searchVo: IRemainingSearch) {
        const apiUrl = "/remainingMonitoring/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }
}

export const remainingService = new RemainingService();
